import React from 'react';
import { Drawer } from 'vaul';
import { useState, useEffect, memo } from 'react';

function ARDrawer({ title, description, direction, children, openEvent }) {
	const [open, setOpen] = useState(false);
	const [props, setProps] = useState({
		variants: [],
		template: '',
		arAssets: [],
		title: '',
		vendor: '',
		handle: '',
	});

	useEffect(() => {
		const handleOpen = (e) => {
			setOpen(true);
			localStorage.setItem('usedARDrawer', true);
			if (e?.detail) setProps((prev) => ({ ...prev, ...e?.detail }));
		};

		window.addEventListener(openEvent, handleOpen);
		window.dispatchEvent(new CustomEvent(`${title}-ready`));

		return () => {
			window.removeEventListener(openEvent, handleOpen);
		};
	}, []);

	const handleOpenChange = (opened) => {
		setOpen(opened);
		if (opened) {
			handleOpenEvent();
			window.dispatchEvent(new CustomEvent(`${openEvent}-success`));
		} else {
			handleCloseEvent();
		}
	};

	const handleClose = (href) => {
		setOpen(false);
		handleCloseEvent();

		if (href) {
			window.location.href = href;
		}
	};

	const handleOpenEvent = () => {
		const eventName = `${title} Open`;
		window.igEvents = window.igEvents || [];
		window.igEvents.push({
			event: eventName,
		});

		if (window.gtag) {
			window.gtag('event', eventName);
		}
	};

	const handleCloseEvent = () => {
		const eventName = `${title} Close`;
		window.igEvents = window.igEvents || [];
		window.igEvents.push({
			event: eventName,
		});

		if (window.gtag) {
			window.gtag('event', eventName);
		}
	};

	return (
		<Drawer.Root
			open={open}
			onOpenChange={handleOpenChange}
			direction={direction}
		>
			<Drawer.Portal>
				<Drawer.Overlay className="tw-fixed tw-inset-0 tw-bg-black/50 tw-z-[1080] md:tw-hidden" />
				<Drawer.Content className="tw-z-[1090] tw-bg-white tw-flex tw-flex-col tw-rounded-t-xl tw-mt-24 tw-h-auto xs:tw-h-5/6 tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-outline-none md:tw-hidden">
					<div className="tw-px-5 tw-pb-5 tw-pt-3 tw-bg-white tw-rounded-t-xl tw-flex-1 tw-overflow-y-auto">
						<div
							aria-hidden
							className="tw-mx-auto tw-w-12 tw-h-1.5 tw-rounded-full tw-bg-black tw-opacity-25 tw-mb-6"
						/>
						<Drawer.Title className="tw-text-sm tw-tracking-1 tw-uppercase tw-font-sans tw-font-normal tw-sr-only">
							{title}
						</Drawer.Title>
						<Drawer.Description className="tw-text-sm tw-tracking-1 tw-uppercase tw-font-sans tw-font-normal tw-sr-only">
							{description}
						</Drawer.Description>
						{children({ handleClose, ...props })}
					</div>
				</Drawer.Content>
			</Drawer.Portal>
		</Drawer.Root>
	);
}

export default memo(ARDrawer);
